/**
 * Shared catalog for scheduled reports (`ReportSchedule.reportType`) and date windows.
 * Keys must stay aligned with `backend/src/report-schedule/report-schedule-dispatcher.service.ts`.
 */

/** Same values as `/ticketing/requests?range=` and backend `ticket-date-range` util. */
export const TICKETING_REPORT_DATE_RANGE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'this_week', label: 'This week' },
  { value: 'this_month', label: 'This month' },
  { value: 'this_quarter', label: 'This quarter' },
  { value: 'this_year', label: 'This year' },
];

/** Built-in schedulable reports (expand over time). */
export const SCHEDULED_REPORT_OPTIONS = [
  {
    value: 'report_link',
    label: 'Report page URL (link in email only)',
  },
  {
    value: 'ticketing_status_analytics',
    label: 'Report Scheduling → Ticketing Report',
  },
  {
    value: 'open_todos',
    label: 'Report Scheduling → Open Todos',
  },
  {
    value: 'year_analytics',
    label: 'Reports & Analytics (year page URL)',
  },
];

/** Year-scoped Reports & Analytics paths (pair with `?year=YYYY`). */
export const YEAR_ANALYTICS_REPORT_URLS = [
  '/reports/complaint',
  '/reports/risk-assessment',
  '/reports/deviation',
  '/reports/product-status-change',
  '/reports/todo',
  '/reports/ticketing',
  '/reports/manuals',
  '/reports/contracts',
];
